import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { DetailInfoComponentModel } from "../../models/components.model";
import Grid from "@mui/material/Grid";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import DocumentInfoComponent from "./documentInfoComponent";
import NoImageFoundDocument from "../thumbnail/noImageFoundDocument";
import { whitespace } from "stylis";

export default function DetailInfoComponentThumbnail({
  sections,
  data,
  documentList,
  title,
  height,
  addressByInquiry,
  showFooter,
  showDoc,
  modal,
  isGuarantor,
  compareHistory,
  headerHeight,
  align,
}: DetailInfoComponentModel) {
  const [detailSections, setDetailSections] = useState(sections);
  useEffect(() => {
    setDetailSections(sections);
  }, [sections]);
  const [detailData, setDetailData] = useState(data);
  useEffect(() => {
    setDetailData(data);
  }, [data]);

  return (
    // <div className="row mTop20">
    <>
      <Grid
        container
        xs={12}
        style={headerHeight ? { height: headerHeight } : {}}
      >
        <Grid
          container
          xs={11}
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 4, sm: 8, md: 12 }}
          style={
            align
              ? { alignSelf: "center" }
              : { marginTop: "0vh", marginBottom: "3vh" }
          }
        >
          {detailSections.map((section) => {
            let value = detailData ? detailData[section.dataKey!] : "";

            if (section.dataKey == "deliveryTime" && detailData) {
              let deliveryTime = detailData["deliveryDate_Persian"]?.split(" ");
              if (deliveryTime && deliveryTime.length > 0) {
                value = deliveryTime[1];
              }
            } else if (
              section.dataKey == "deliveryDate_Persian" &&
              detailData
            ) {
              let deliveryTime = detailData["deliveryDate_Persian"]?.split(" ");
              if (deliveryTime && deliveryTime.length > 0) {
                value = deliveryTime[0];
              }
            } else if (value && section.hasThousandSeparatorFormat) {
              value = value.toLocaleString("fa");
            }

            if (!value) {
              return (
                <Grid
                  className="confirm"
                  item
                  xs={section.rowCol}
                  sm={4}
                  md={section.rowCol}
                  style={{ marginRight: "-4vh" }}
                >
                  <Typography
                    className="divRequestDetail "
                    style={{ width: "100%" }}
                  >
                    {<span className="secColor"> {section.title}: </span>}
                    <span className="fontBlueColor textFont14">--</span>
                  </Typography>
                </Grid>
              );
            }

            return (
              <Grid
                className="confirm"
                item
                xs={section.rowCol}
                sm={4}
                md={section.rowCol}
                style={{ marginRight: "-4vh" }}
              >
                <Typography
                  className="divRequestDetail "
                  style={{ width: "100%" }}
                >
                  {<span className="secColor"> {section.title}: </span>}
                  <span
                    className="fontBlueColor textFont14 fontWeight"
                    style={
                      section.dataKey == "inquiryDueDatePersian" &&
                      compareHistory == true
                        ? {
                            backgroundColor: "#ee9d01",
                            color: "#fff",
                            borderRadius: "5px",
                            paddingRight: "5px",
                            paddingLeft: "5px",
                          }
                        : section.dataKey == "inquiryDueDatePersian" &&
                          compareHistory == false &&
                          value
                        ? {
                            backgroundColor: "#28a745",
                            color: "#fff",
                            borderRadius: "5px",
                            paddingRight: "5px",
                            paddingLeft: "5px",
                          }
                        : section.dataKey == "acceptDate_Persian" && value
                        ? {
                            backgroundColor: "#28a745",
                            color: "#fff",
                            borderRadius: "5px",
                            paddingRight: "5px",
                            paddingLeft: "5px",
                          }
                        : { backgroundColor: "#fff" }
                    }
                  >
                    {(section.dataKey === "insuranceAmount" ||
                      section.dataKey === "estimatedPrice" ||
                      section.dataKey === "acceptDate_Persian") &&
                    !value ? (
                      "..."
                    ) : (
                      <>
                        {section.dataKey === "inquiryReasonTitle" &&
                          value &&
                          `${value} - ${detailData["inquiryReasonCode"]}`}
                        {value} {value ? section.dataPostValue : ""}
                      </>
                    )}
                  </span>
                </Typography>
              </Grid>
            );
          })}
        </Grid>
        {modal ? (
          <Grid item xs={1}>
            <Typography
              className="divRequestDetail "
              style={{ paddingTop: "2vh" }}
            >
              {modal}
            </Typography>
          </Grid>
        ) : (
          ""
        )}
      </Grid>

      {!isGuarantor ? documentList ? <hr /> : "" : ""}
      {/* {documentList ? <hr /> : ""} */}

      <Grid
        container
        xs={12}
        spacing={2}
        columns={{ xs: 2, sm: 8, md: 12 }}
        // color={`${workflowStepType == "Forward" ? "#28A745" : "#e6123d"}`}
        style={{ paddingInline: "3vh", direction: "rtl" }}
        className={`${isGuarantor == true ? "directionLTR" : "directionRTL"}`}
      >
        {showDoc == undefined || showDoc == true
          ? documentList?.map((item: any) => (
              <Grid item xs={2}>
                {item?.fileUrl ? (
                  <DocumentInfoComponent
                    data={item}
                    title={isGuarantor ? item.documentTypeTitle : title}
                    showFooter={showFooter}
                    height={height}
                    isGuarantor={isGuarantor ? isGuarantor : false}
                  />
                ) : (
                  <NoImageFoundDocument />
                )}
              </Grid>
            ))
          : null}
      </Grid>
      <Grid className="confirm centerVertical" xs={12}>
        {addressByInquiry &&
        ((data?.addressByInquiry != undefined &&
          data?.addressByInquiry != null &&
          data?.addressByInquiry != "") ||
          (data?.addressInquiry != undefined &&
            data?.addressInquiry != null &&
            data?.addressInquiry != "")) ? (
          <div
            style={{
              width: "100%",
              background: "#E5F7EC",
              padding: "1.2vh",
              // marginBottom: "2vh",
              // border: "solid #707070 .5px",
              boxShadow:
                "0 0px 1.1px 0 rgba(0, 0, 0, 0), 0 1.1px 1.1px 0 rgba(0, 0, 0, 0.5)",
              borderRadius: "5px",
            }}
            className="centerVertical"
          >
            <b style={{ color: "#01AF43", fontSize: "1em" }}>
              &nbsp;&nbsp; <CheckCircleIcon /> استعلام آدرس از سامانه پست انجام
              شد.
            </b>{" "}
            &nbsp;&nbsp;
            <b style={{ color: "##212121", fontSize: "1em" }}>
              &nbsp;&nbsp; | &nbsp;&nbsp; &nbsp;&nbsp;
              {data?.addressByInquiry! || data?.addressInquiry!}
              &nbsp;&nbsp;
            </b>
          </div>
        ) : null}
      </Grid>
    </>
  );
}
